import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  inject,
  viewChild
} from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { AppDomService } from 'src/app/core/services/dom.service';

import { BreakpointObserver } from '@angular/cdk/layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { TranslationModule } from 'src/app/i18n';

@Component({
    selector: 'emoji-picker',
    imports: [CommonModule, PickerModule, MatTooltipModule, TranslationModule],
    templateUrl: './emoji-picker.component.html'
})
export class EmojiPickerComponent {
  appStateService = inject(AppStateService);

  //#region properties

  @Input() isHeightChange: boolean;
  readonly container = viewChild<ElementRef<HTMLElement>>('container');
  isEmojiPickerVisible: boolean;
  @Output() emoji = new EventEmitter<any>();
  emojisToShowFilter = (unicode) => true;

  //#endregion

  constructor(private brObs: BreakpointObserver, private renderer: Renderer2) {}

  ngOnInit(): void { }

  /** event Handler for clicks outside the emoji picker, the emoji picker will be closed*/
  eventHandler = (event: Event) => {
    if (!this.container()?.nativeElement.contains(event.target as Node)) {
      this.isEmojiPickerVisible = false;
      window.removeEventListener('click', this.eventHandler);
    }
  };

  /** handle emoji picker visitable*/
  toggled() {
    if (!this.container()) return;
    this.isEmojiPickerVisible = !this.isEmojiPickerVisible;
    if (this.isEmojiPickerVisible)
      window.addEventListener('click', this.eventHandler);
    else window.removeEventListener('click', this.eventHandler);

    this.handleEmojiPickerPosition();
  }

  async handleEmojiPickerPosition() {
    const emojiMartBodyElement = await AppDomService.getElementByQueryAsync(
      '.emoji-mart-scroll'
    );
    this.isInViewport(emojiMartBodyElement as HTMLElement);
  }

  async isInViewport(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    const emojiMartElement = (await AppDomService.getElementByQueryAsync(
      'emoji-mart'
    )) as HTMLElement;

    if (rect.left < 0) {
      //   emojiMartElement.style.right = '0px';
      //   emojiMartElement.style.bottom = '0px';
      //   emojiMartElement.style.left = 'unset';
      this.renderer.setStyle(emojiMartElement, 'right', '0px');
      this.renderer.setStyle(emojiMartElement, 'bottom', '0px');
      this.renderer.setStyle(emojiMartElement, 'left', 'unset');
    } else if (rect.right < 0) {
      //   emojiMartElement.style.left = '0px';
      //   emojiMartElement.style.bottom = '0px';
      //   emojiMartElement.style.right = 'unset';
      this.renderer.setStyle(emojiMartElement, 'left', '0px');
      this.renderer.setStyle(emojiMartElement, 'bottom', '0px');
      this.renderer.setStyle(emojiMartElement, 'right', 'unset');
    }

    // return (
    //   rect.top >= 0 &&
    //   rect.left >= 0 &&
    //   rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //   rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    // );
  }

  /** emit selected emoji*/
  emitEmoji(event) {
    this.emoji.emit(event);
  }
}
